import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { apiDelete, apiGet, apiPost } from "../../../components/Common/Axios";
import { UserRole } from "../../../lib/types";
import Popup from "../../../components/Common/Popup";
import UserPopup from "./UserPopup";
import { User } from "lib/models";
import { Button } from "components/ui/button";

function SettingLog() {
  const [logs, setLogs] = useState([]);

  const loadLogs = async () => {
    const response = await apiGet("/logs");
    if (response.error) {
      toast.error("로그 목록을 불러오는데 실패했습니다.");
      console.error("loadLogs.error", response.error);
      return;
    }
    setLogs(response.data);
  };

  useEffect(() => {
    loadLogs();
  }, []);

  return (
    <div className="w-full text-sm overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
      <div className="min-w-[640px]">
        <div className="grid grid-cols-[60px_140px_120px_1fr] bg-gray-50 text-gray-500 font-medium p-2">
          <div className="text-center">No</div>
          <div className="text-center">생성일시</div>
          <div className="text-center">행동</div>
          <div className="text-center">로그</div>
        </div>
        {logs.map((log: any, index) => {
          return (
            <div
              className="grid grid-cols-[60px_140px_120px_1fr] p-2"
              key={log.id}
            >
              <div className="text-center">{index + 1}</div>
              <div className="text-center">
                {log.createdAt.toLocaleString("ko-KR", {
                  timeZone: "Asia/Seoul",
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false,
                })}
              </div>
              <div className="text-center">{log.action}</div>
              <div className="text-center">{log.message}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SettingLog;
